import { createAsyncThunk } from "@reduxjs/toolkit";

import config from "config/config";
import { getToken } from "js/formatting/getToken";
import moment from "moment/moment";

export const getCommission = createAsyncThunk(
  "getCommission",
  async (agentId, { rejectWithValue, fulfillWithValue }) => {
    try {
      let options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
          Authorization: `bearer ${getToken()}`,
        },
        body: JSON.stringify({
          gXdpApi: {
            transactionType: {
              sourceNameSpace: "ODS",
              targetNameSpace: "GIDP",
              operation: "GET",
              eventName: "GETCOMMISSION",
            },
            correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
            addOnProperties: {},
            gIdpPayLoad: {
              agent: {
                agentId: agentId,
              },
              addOnProperties: {
                company: config.COMPANY,
                clientName: config.CLIENTNAME,
                system: "LSN",
                lifesysDataset: "P",
                logTimeStamp: "",
              },
            },
          },
        }),
      };

      const response = await fetch(
        config.ODS_API_BASE_URL + "/evl/GetCommissions",
        options
      );

      if (!response.ok) {
        return rejectWithValue(response);
      }

      const data = await response.json();
      if (data?.gXdpApi?.success) {
        return fulfillWithValue(data?.gXdpApi?.gIdpPayLoad?.agent);
      } else {
        return rejectWithValue(data?.gXdpApi?.gIdpPayLoad?.errorMessage);
      }
    } catch (error) {
      throw rejectWithValue(error.message);
    }
  }
);
